'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var useDefaultInternalState = require('../../hooks/useDefaultInternalState.js');
var SimpleCheckboxRadio = require('./SimpleCheckboxRadio.js');

var Checkbox = react.forwardRef(function (_a, ref) {
    var _b = _a.type, type = _b === void 0 ? 'checkbox' : _b, checked = _a.checked, error = _a.error, _c = _a.hideError, hideError = _c === void 0 ? false : _c, _d = _a.id, id = _d === void 0 ? '' : _d, onChange = _a.onChange, setChecked = _a.setChecked, setError = _a.setError, validator = _a.validator, _e = _a.value, value = _e === void 0 ? '' : _e, _f = _a.size, size = _f === void 0 ? 'dynamic' : _f, props = tslib.__rest(_a, ["type", "checked", "error", "hideError", "id", "onChange", "setChecked", "setError", "validator", "value", "size"]);
    var _g = useDefaultInternalState.default(checked, setChecked), checkedState = _g[0], setCheckedState = _g[1];
    var _h = useDefaultInternalState.default(error, setError), errorState = _h[0], setErrorState = _h[1];
    var handleChange = function (e) {
        var newChecked = e.target.checked;
        var newCheckedValue = e.target.value;
        if (validator) {
            var result = validator(newChecked, newCheckedValue);
            setErrorState(result);
        }
        else {
            setErrorState();
        }
        setCheckedState(newChecked);
        onChange && onChange(e);
    };
    return (jsxRuntime.jsx(SimpleCheckboxRadio.default, tslib.__assign({ checked: checkedState, error: errorState, hideError: hideError, id: id, onChange: handleChange, type: type, value: value, size: size, ref: ref }, props)));
});
Checkbox.displayName = 'Checkbox';
var Checkbox$1 = Checkbox;

exports.default = Checkbox$1;
//# sourceMappingURL=Checkbox.js.map
